import { useIsTouchScreen } from "@/hooks/useIsTouchScreen";

import { INVALID_FORM_REASON } from "./constants";

/**
 * Why a submit button is disabled while its form is invalid, or undefined when it stays pressable.
 * With a mouse the button is disabled and its reason shows on hover or keyboard focus. On a touch
 * screen it stays pressable and the press shows each field's error, since a tap on a disabled
 * button is easy to miss.
 */
export function useInvalidSubmitReason(isValid: boolean): string | undefined {
  const isTouchScreen = useIsTouchScreen();

  return !isValid && !isTouchScreen ? INVALID_FORM_REASON : undefined;
}
